module.exports = __webpack_public_path__ + "img/Facebook-small.f3ac02ac.svg";